import { useLocation, useNavigate } from 'react-router-dom';
import ButtonText from '~/components/ui/button-text';
import iconPresert from '@assets/images/icon/icon-gift.png';
import GameLayout from './GameLayout';
import styled from 'styled-components';
import { WrapperItem } from '~/components/ui/wrapper-item';
import { useLingui } from '@lingui/react';
import { SSpanText } from '~/components/styles/styles';

const BattleRecap = () => {
  const navigate = useNavigate();
  const {
    state: { isWinner, opponent },
  } = useLocation();
  const { i18n } = useLingui();

  return (
    <GameLayout withoutHeader withoutFooter>
      <SDivBlur $background />
      <Container>
        {isWinner ? (
          <WrapperItem
            customIconHeight="50%"
            customIconWidth="50%"
            iconSrc={iconPresert}
            title={`${i18n._('common.congratulations')} !`}
          >
            <SSpanText>{`${i18n._('battle.notif.text.won')} ${opponent} !`}</SSpanText>
            <SDivBtn>
              <ButtonText
                color="primary"
                onClick={() => navigate('/home')}
                margin="20px 0 0 0"
                textTransform={'uppercase'}
              >
                {i18n._('common.back')}
              </ButtonText>
            </SDivBtn>
          </WrapperItem>
        ) : (
          <WrapperItem title={i18n._('battle.notif.title.without')}>
            <SSpanText>{`${i18n._('battle.notif.text.lost')} ${opponent} !`}</SSpanText>
            <SDivBtn>
              <ButtonText
                color="primary"
                onClick={() => navigate('/home')}
                margin="20px 0 0 0"
                textTransform={'uppercase'}
              >
                {i18n._('common.back')}
              </ButtonText>
            </SDivBtn>
          </WrapperItem>
        )}
      </Container>
    </GameLayout>
  );
};

export default BattleRecap;

const SDivBlur = styled.div<{ $background?: boolean }>`
  background: ${({ $background }) =>
    $background
      ? `linear-gradient(180deg, rgba(0, 202, 191, 0.60) 0%, rgba(0, 173, 212, 0.60) 100%)`
      : 'none'};
  backdrop-filter: ${({ $background }) =>
    $background ? `blur(18px)` : 'none'};
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Container = styled.div`
  padding: 5px;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
